'use client';

import { useState } from 'react';
import PropertyNavBar from './property-navbar';
import OverviewTab from './overview-tab';
import AmenitiesTab from './tabs/amenities-tab';
import SleepTab from './tabs/sleep-tab';
import LocationTab from './tabs/location-tab';
import PricingTab from './tabs/pricing-tab';
import ReviewsTab from './tabs/reviews-tab';

const TABS = [
    <OverviewTab key="overview" />,
    <AmenitiesTab key="amenities" />,
    <SleepTab key="sleep" />,
    <LocationTab key="location" />,
    <PricingTab key="pricing" />,
    <ReviewsTab key="reviews" />,
];

export default function PropertyTabs() {
    const [selected, setSelected] = useState(0);

    return (
        <div>
            <div id="property-navbar" className="max-lg:w-screen max-lg:-mx-6 max-lg:px-6 top-[70px]">
                <PropertyNavBar selected={selected} onTabChange={setSelected} />
            </div>
            <div id="property-tabs" className="pt-5">
                {TABS[selected]}
            </div>
        </div>
    )
}